import { useEffect } from 'react';

import { deleteCitationRequestReviewStore } from '../state/citationRequestReviewStore';

/**
 * Releases the per-citation-request review store when the component
 * that owns the request unmounts (or when `citationRequestId` changes).
 * Mirrors `useStatementReferencesStoreCleanup` so the registry does not
 * accumulate stale entries across a long conversation session.
 */
export function useCitationRequestReviewStoreCleanup(citationRequestId: string | undefined): void {
  useEffect(() => {
    return () => {
      if (citationRequestId) {
        deleteCitationRequestReviewStore(citationRequestId);
      }
    };
  }, [citationRequestId]);
}
